module.exports = __webpack_public_path__ + "img/no-data.a761c32f.png";